export default __webpack_public_path__ + "static/media/Transferability documentation.fe915766.pdf";